import { Box } from '@mui/material';
import * as React from 'react';
import UsersTable from './usersTable';

export default function UsersLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <UsersTable />
    </Box>
  );
}
